import { render, staticRenderFns } from "./SetPromotion.vue?vue&type=template&id=1c0581bc&scoped=true"
import script from "./SetPromotion.vue?vue&type=script&lang=js"
export * from "./SetPromotion.vue?vue&type=script&lang=js"
import style0 from "./SetPromotion.vue?vue&type=style&index=0&id=1c0581bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0581bc",
  null
  
)

export default component.exports